import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CountryDto } from '@assetaccountant/api/models/country.dto';
import { OfferKey } from '@assetaccountant/api/models/offer-key';
import { OrganisationV2Api } from '@assetaccountant/api/services/organisation-v2.api';
import { RegisterApi } from '@assetaccountant/api/services/register.api';
import { IzePipe } from '@assetaccountant/core/pipes/ize.pipe';
import { LayoutService } from '@assetaccountant/core/services/layout.service';
import { TrackingService } from '@assetaccountant/core/services/tracking.service';
import { emptyValue, TypedFormBuilder } from '@assetaccountant/core/utils/typed-forms';
import { finalize, tap } from 'rxjs/operators';

@Component({
  selector: 'app-create-first-organisation',
  templateUrl: './create-first-organisation.component.html',
  styleUrls: ['./create-first-organisation.component.scss'],
  standalone: false,
})
export class CreateFirstOrganisationComponent implements OnInit {
  countries: CountryDto[] = [];

  private offerKey: OfferKey | undefined;

  form = this.fb.group({
    name: [emptyValue<string>(), [Validators.required, Validators.maxLength(128)]],
    countryId: [emptyValue<number>(), Validators.required],
  });

  submitting = false;

  get title() {
    return {
      pageTitle: this.izePipe.transform('Create Your Organisation'),
    };
  }

  constructor(
    private organisationApi: OrganisationV2Api,
    private router: Router,
    private fb: TypedFormBuilder,
    private layoutService: LayoutService,
    private registerApi: RegisterApi,
    private trackingService: TrackingService,
    private route: ActivatedRoute,
    private izePipe: IzePipe,
  ) {
    this.trackingService.initaliseUserTracking(true);
  }

  ngOnInit() {
    this.trackingService.startSessionReplay();
    this.trackingService.trackEvent('Create first organisation (init)');

    this.registerApi.getCountries().subscribe(result => {
      this.countries = result;
    });
    const campaignKey = this.route.snapshot.paramMap.get('campaignKey');
    if (campaignKey != null) {
      this.offerKey = {
        campaignKey,
        couponId: this.route.snapshot.paramMap.get('couponId'),
      } as OfferKey;
    }
  }

  onSubmit() {
    if (this.form.valid) {
      this.submitting = true;
      this.organisationApi
        .createOrganisation({
          name: this.form.value.name,
          description: '',
          countryId: this.form.value.countryId,
          billingContactDetails: undefined,
          offer: this.offerKey,
          source: this.trackingService.getMarketingSource(),
        })
        .pipe(
          tap({
            error: () => (this.submitting = false),
          }),
        )
        .subscribe(organisationResponse => {
          this.trackingService.trackEvent('Create first organisation (submit)');

          const organisationId = organisationResponse.organisation.id;

          this.organisationApi
            .createDemoRegister(organisationId)
            .pipe(
              finalize(() => {
                this.router.navigate([`/organisations/${organisationId}/start`]);
                this.layoutService.triggerNavRefresh();
              }),
            )
            .subscribe({
              next: () => this.layoutService.demoRegisterCreated.next(),
              error: () => {},
            });
        });
    }
  }
}
